import React, { ReactNode } from 'react';
import { Card } from 'antd';

interface CardLayoutProps {
  children: ReactNode;
  style?: React.CSSProperties;
}

const CardLayout: React.FC<CardLayoutProps> = ({ children, style = {} }) => {
  return (
    <Card
      style={{
        ...style,
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
      }}>
      {children}
    </Card>
  );
};

export default CardLayout;
